jQuery(function ($){

  setTimeout(step_1, 6000)
  let slideIndex = 0
  let x = 0

  function showNextSlide() {

    if( slideIndex + 1 == $('.fx-slider__item').length) {
      slideIndex = 0
    } else {
      slideIndex++
    }

    $('.fx-slider__item').removeClass('active');
    $('.fx-slider__item').eq(slideIndex).addClass('active');
  }

  function checkStep_1() {
    if (x == 2) {
      x = 0
      setTimeout(step_2, 300);
    }
  }

  function checkStep_2() {
    if(x == 1) {
      x = 0
      setTimeout(step_3, 1000);
    }
  }

  function checkStep_3() {
    if(x == 1) {
      setTimeout (step_1, 6000)
      x = 0
    }
  }
  
  function step_1() {
    $('.fx-slider__background, .fx-slider__logo').fadeIn(1000, "linear", function() {
      x++;
      checkStep_1()
    }); 
  }

  function step_2() {
    $('.fade').addClass('active')
    x++;
    checkStep_2()
  }

  function step_3() {
    $('.fx-slider__logo').hide()
    $('.fx-slider__background').fadeOut(1000)
    showNextSlide();
    $('.fade').removeClass('active')
    x++;
    checkStep_3()
  }

});
